import { Input, Button } from '@faststore/ui'
import React, { useState } from 'react'

interface InteractionProps {
  handleNewsLatter: (email: string) => void
}

const Interaction = ({ handleNewsLatter }: InteractionProps) => {
  const [emailInput, setEmailInput] = useState('')

  return (
    <div className="newslatter-interaction">
      <Input
        className="newsletter-input"
        id="newsletter-email"
        type="email"
        name="newsletter-email"
        onChange={(email) => setEmailInput(email.target.value)}
        placeholder="E-mail"
      />
      <Button
        testId="newsletter-btn"
        className="newsletter-button"
        onClick={() => {
          handleNewsLatter(emailInput)
        }}
      >
        Cadastrar
      </Button>
    </div>
  )
}

export default Interaction
